<template>
  <div>
    <DxPopup
      :visible="showPopup"
      :drag-enabled="false"
      :hide-on-outside-click="false"
      :show-title="true"
      :width="500"
      height="auto"
      :show-close-button="false"
      :title="$t('Confirm_Delete_Title')"
    >
      <template>
        <f7-block
          class="text-align-center center"
        >
          <div>
            <f7-icon
              class="warning-icon"
              md="material:warning"
            />
          </div>
          <div
            class="title font-size-20"
          >
            {{ $t('pendingRegister') }}
          </div>
        </f7-block>
        <f7-block class="text-align-center">
          <p>{{ $t('pendingObservationMessage') }}</p>
        </f7-block>
      </template>
      <div class="padding-top">
        <f7-row>
          <f7-col>
            <f7-button
              class="dx-btn-cancel margin-left-block btn-width-150 outlined-gray margin-top-block margin-bottom-block"
              raised
              type="default"
              styling-mode="contained"
              @click="goToPage"
            >
            {{ $t("abandon") }}
            </f7-button>
          </f7-col>
          <f7-col class="justify-content-end">
            <f7-button
              class="dx-btn-cancel margin-right-block btn-width-150 margin-top-block margin-bottom-block standard-blue-btn"
              raised
              type="success"
              styling-mode="contained"
              @click="onHidden"
            >
              {{ $t("continue") }}
            </f7-button>
          </f7-col>
        </f7-row>
      </div>
    </DxPopup>
  </div>
</template>

<script>

import { mapActions, mapState } from 'vuex';
import { DxPopup } from 'devextreme-vue/popup';

export default {
  name: 'PopupConfirmObservationExit',
  components: {
    DxPopup,
  },
  computed: {
    showPopup() {
      return this.displayConfirmExitPopup;
    },
    ...mapState('Observations', ['displayConfirmExitPopup', 'routeToGo']),
    ...mapState('Utilities', ['tabToGo']),
    ...mapState('SearcherObservations', ['category'])
  },
  methods: {
    onHidden() {
      this.setDisplayConfirmExitPopup(false);
    },
    goToPage() {
      this.setDisplayConfirmExitPopup(false);
      this.setCurrentTab(this.tabToGo);
      this.setActualMenuSelected(this.routeToGo);
      this.$f7.views.main.router.navigate(this.routeToGo, { reloadCurrent: true });
    },
    ...mapActions('Observations', ['setDisplayConfirmExitPopup']),
    ...mapActions('Utilities', ['setCurrentTab']),
    ...mapActions('authentication', ['setActualMenuSelected']),
  },
};
</script>

<style src="./popupConfirmObservationExit.styles.scss" scoped lang="scss"></style>
